export interface ApiSuccessResponse<T> {
  success: true;
  message: string;
  data: T;
}

export interface ApiErrorResponse {
  success: false;
  message: string;
  code?: string;
}

export type ApiResponse<T> = ApiSuccessResponse<T> | ApiErrorResponse;

export class ApiError extends Error {
  constructor(message: string) {
    super(message);
    this.name = 'ApiError';
  }
}

export function assertApiSuccess<T>(res: ApiResponse<T>): asserts res is ApiSuccessResponse<T> {
  if (!res.success) {
    throw new ApiError(res.message);
  }
}

export type AuthErrorCode = 400 | 401 | 403 | 429 | 500;

export function getAuthErrorCode(status: number | undefined): AuthErrorCode {
  if (status === 400 || status === 401 || status === 403 || status === 429 || status === 500) {
    return status;
  }
  return 500;
}
